import React from 'react';
import { Col, Grid, Row } from 'react-bootstrap';


export default props => (
  <Grid fluid>
   
        {props.children}
     
  </Grid>
);



// WEBPACK FOOTER //
// ./src/components/Layout.js